<script setup lang="ts">
import CmsCustomComponent from '~/layers/cms/app/components/cms/CmsCustomComponent.vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()

const nazwa_komponentu = 'Modules with padding/Image'

const component_default_values: CmsCustomComponentType = {
  padding: { value: undefined, selectValues: ['px-xl', 'px-2xl', 'px-4xl', 'px-0'], default_value: 'Lorem Ipsum', settingType: 'select', setting_label: 'zmien padding' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :defaults="component_default_values"
    :component-name="nazwa_komponentu"
    :open-options="true"
  >
    <div
      :class="component_values?.padding?.value"
      class="flex items-center justify-center justify-items-center"
    >
      <CmsImage
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'image']"
        class="rounded-3xl"
      />
    </div>
  </CmsCustomComponent>
</template>
